//numeric_code is deprecated but left here for backward compatibility
export const findCountryByCode = (countries, numeric_code) => {
  return countries.find(
    (c) => c.numeric_code == numeric_code || c.name === numeric_code
  );
};
